import './App.css';
import img_tablet from './tablet.png';

function MarketplaceDevicePreview({ device }) {
    const e6 = 100000;
    return (
        <div className='marketplace-preview-campaign'>
            <div>
                <img src={img_tablet} width={160} />
            </div>
            <div
                style={{
                    marginTop: '0.5em',
                    marginLeft: '0.2em',
                    width: '10em',
                }}
            >
                <div
                    style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {device.title}
                </div>
                <div style={{ marginTop: '0.5em' }}>
                    <b>
                        from {(device.min_price_per_second_e6 / e6 * 60 * 60).toFixed(2)} EUR/h
                    </b>
                </div>
                {/* <div
                    style={{
                        marginTop: '0.5em',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <i
                        className="pi pi-map-marker"
                        style={{ fontSize: '1rem', marginRight: '0.5em' }}
                    />
                    <div>
                        unknown
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default MarketplaceDevicePreview;